<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <v-alert
        v-model="error"
        dismissible
        type="error"
      >
        {{errorMsg}}
      </v-alert>

      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Przenieś do:
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div class="scrollable-height">
            <v-list class="px-0 py-0" v-if="dirList.length > 0 || currentDir">
              <div class="dir__item">
                <v-list-tile
                  v-if="currentDir"
                  @click.native="backDir"
                  class="v-list__tile--link dir__tile"
                  align-center>
                    <div class="pr-2 dir__name">
                      <v-icon color="grey" class="mr-2">
                        folder
                      </v-icon>
                      ...
                    </div>
                </v-list-tile>
              </div>
              <v-radio-group class="pa-0" v-model="selectedDir">
                <div
                  v-for="(item, index) in dirList"
                  :key="index"
                  class="dir__item"
                >
                  <div class="dir__radio mx-3">
                    <v-radio
                      :value="item.id"
                      :color="item.id === selectedDir ? 'white' : 'primary'"
                    ></v-radio>
                  </div>
                  <v-list-tile
                    @click="showDir(item.id)"
                    class="dir__tile"
                    :class="item.id === selectedDir ? 'primary white--text' : ''"
                    >
                    <div class="pr-2 dir__name">
                      <v-icon
                        :color="item.id === selectedDir ? 'white' : 'primary'"
                        class="mr-2 dir__icon">
                        folder
                      </v-icon>
                      {{item.name}}
                    </div>
                  </v-list-tile>
                </div>
              </v-radio-group>
            </v-list>
            <div class="pa-4" v-if="dirList.length < 1">
              <p class="body-2 mb-0">Brak katalogów.</p>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-4">
            <ServerErrors :errorsItems="serverErrors" />
            <v-spacer></v-spacer>
            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>
            <v-btn
              color="primary"
              :loading="busy"
              :disabled="!selectedDir || busy"
              @click="moveItems"
            >
              Przenieś
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getDirList } from './../../../repository/files';
import { getError } from '../../../helpers/helpers';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'move-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    serverErrors: [],
    dialogBusy: true,
    dirList: null,
    selectedDir: null,
    currentDir: null,
    dirBreadCrumb: [],
  }),
  components: {
    ServerErrors,
  },
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'move';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'moveFiles',
    ]),
    clearData() {
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.dialogBusy = true;
      this.dirList = null;
      this.selectedDir = null;
      this.currentDir = null;
      this.dirBreadCrumb = [];
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
    selectDir(id) {
      this.selectedDir = id;
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    backDir() {
      const prevItem = this.dirBreadCrumb.length - 2;
      const prevItemId = this.dirBreadCrumb[prevItem];
      this.dirBreadCrumb.splice(-1, 1);
      this.getDirectoriesList(prevItemId);
    },
    showDir(id) {
      this.dirBreadCrumb.push(id);
      this.getDirectoriesList(id);
    },
    async moveItems() {
      this.busy = true;
      const files = this.dialogVisibility.items_id;
      const moveData = {
        items_id: files,
        dest_item_id: this.selectedDir,
      };
      try {
        await this.moveFiles(moveData);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
    async getDirectoriesList(parentId) {
      this.dialogBusy = true;
      this.selectedDir = null;
      try {
        const params = {
          client_id: this.dialogVisibility.client_id,
          without_directories_id: this.dialogVisibility.items_id,
        };
        if (parentId) params.parent_item_id = parentId;
        const dirList = await getDirList(params);
        this.dirList = dirList.data.data.items;
        this.dialogBusy = false;
        this.currentDir = parentId;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (val) {
        this.getDirectoriesList();
      }
      if (oldVal) {
        this.clearData();
      }
    },
  },
};
</script>
